export const getCategoryItemUrl = (categoryItem) => {
  if(
    !categoryItem
    || typeof categoryItem !== "object"
    || categoryItem.id === undefined
  ) return undefined;

  return `/category/${categoryItem.id}`;
};
